import { render } from "./GridAdvertisedPrice.vue?vue&type=template&id=487eb3d6"
import script from "./GridAdvertisedPrice.vue?vue&type=script&lang=js"
export * from "./GridAdvertisedPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__